import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVlmById, saveVlmById } from '../../api/vlm.api'
import { fetchDispath } from '../../functions/fetch'
import { Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { API_BO } from '../../conf'

const STATUS = {
  queued: 'QUEUED',
  running: 'RUNNING',
  paused: 'PAUSED',
  stopped: 'STOPPED',
  failed: 'FAILED',
  finished: 'FINISHED',
  unspecified: 'STATUS_UNSPECIFIED',
}
const column = [
  "Позиция",
  "Наименование и техническая характеристика",
  "Тип, марка, обозначение",
  "Код оборудования, изделия, материала",
  "Поставщик",
  "Единица измерения",
  "Количество",
  "Масса единицы",
  "Примечание",
]
export default function VlmOne(props) {
  const [res, setRes] = useState([])
  const [status, setStatus] = useState(STATUS.unspecified)
  const [errorStatus, setErrorStatus] = useState({
    errorCode: "",
    message: ""
  })
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchDispath({
      param: {
        id: props.match.params.idDoc
      },
      progress: true,
      request: getVlmById,
    }))
      .then((res) => {
        if (!res) return;
        setStatus(res.get.status);
        setErrorStatus(res.get.error);
        setRes(res.get?.result?.ocrgemma?.items || []);
      })
  }, [dispatch, props.match.params.idDoc,])

  const handleReload = () => {
    dispatch(fetchDispath({
      param: {
        id: props.match.params.idDoc
      },
      progress: true,
      request: getVlmById,
    }))
      .then((res) => {
        if (!res) return;
        setStatus(res.get.status);
        setErrorStatus(res.get.error);
        setRes(res.get?.result?.ocrgemma?.items || []);
      })
  }

  const handleSave = () => {
    dispatch(fetchDispath({
      param: {
        id: props.match.params.idDoc
      },
      progress: true,
      request: saveVlmById,
    }))
      .then((res) => {
        if (!res) return;
        const id = res.get;
        props.history.push(`${API_BO}/workdoc/${id}`)
      })
  }
  if (status === STATUS.queued || status === STATUS.running) {
    return <div className='App-paper'>
      <Button color="primary" onClick={() => props.history.goBack()}>Назад </Button>
      <Button color="primary" onClick={handleReload}>Обновить </Button><br />
      Статус: {status}<br />
    </div>
  }
  if (status === STATUS.failed) {
    return <div className='App-paper'>
      <Button color="primary" onClick={() => props.history.goBack()}>Назад </Button><br />
      Статус: {status}<br />
      errorCode:  "{errorStatus.errorCode}"<br />
      message: "{errorStatus.message}"<br />
    </div>
  }
  if (status !== STATUS.finished) {
    return <div className='App-paper'>
      <Button color="primary" onClick={() => props.history.goBack()}>Назад </Button><br />
      Статус: {status}
    </div>
  }
  return <div className='App-paper'>
    <Button color="primary" onClick={() => props.history.goBack()}>Назад </Button>
    <Button color="primary" onClick={handleSave}>Сохранить в РД </Button>
    <Table>
      <TableHead>
        <TableRow>
          {column.map(key => {
            return <TableCell key={key}>{key}</TableCell>
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {res.map((obj, i) => {
          return <TableRow key={i}>
            {column.map(key => {
              return <TableCell key={`${key}_${i}`}>{obj[key]}</TableCell>
            })}
          </TableRow>
        })}
      </TableBody>
    </Table>
  </div>
}